var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{class:{ 'position': _vm.hasSpinner }},[_vm._v(" © Copyright "+_vm._s(_vm.currentFullYear)+" Instituto Mix de Profissões - Todos os direitos reservados. "),_c('img',{attrs:{"src":require("@/assets/images/poweredby-white.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }